import { render, staticRenderFns } from "./SuccessMessage.vue?vue&type=template&id=3bcd3b03&scoped=true&"
import script from "./SuccessMessage.vue?vue&type=script&lang=ts&"
export * from "./SuccessMessage.vue?vue&type=script&lang=ts&"
import style0 from "./SuccessMessage.vue?vue&type=style&index=0&id=3bcd3b03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcd3b03",
  null
  
)

export default component.exports